import React from 'react';
import {Autocomplete, TextField} from '@mui/material';
import {getBankSelectOptions, matchBankOption} from '../../../../../types/DocumentsTypes/utils';

export const BankAutocomplete = ({
    value,
    onChange,
    size,
    sx,
    label = 'בנק',
}: {
    value: string | number | undefined;
    onChange: (bank: string | undefined) => void;
    size?: 'small' | 'medium';
    sx?: object;
    label?: string;
}) => {
    const options = React.useMemo(() => getBankSelectOptions(), []);
    const selected = matchBankOption(value, options);
    return (
        <Autocomplete
            id='bank'
            fullWidth
            size={size}
            sx={sx}
            options={options}
            value={selected}
            autoHighlight
            autoSelect
            getOptionLabel={(option) => option ?? ''}
            isOptionEqualToValue={(a, b) => a === b}
            onChange={(_event, next) => onChange(next || undefined)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
};
